import React from 'react'
// nodejs library that concatenates classes
import classNames from 'classnames'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'

// @material-ui/icons
import SearchIcon from '@material-ui/icons/Search'
import GroupIcon from '@material-ui/icons/Group'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance'

// core components
import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'
import Card from 'components/Card/Card.js'

import styles from 'assets/jss/material-kit-react/views/indexPageSections/ideaStyle.js'

import architecture from 'assets/img/indexPage/architecture.jpg'

const useStyles = makeStyles(styles)

export default function IdeaSection() {
  const classes = useStyles()
  const imageClasses = classNames(classes.imgRaised, classes.imgRounded, classes.imgFluid)
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h2 className={classes.title}>理念超前化</h2>
          <h5 className={classes.description}>坚持可持续发展、科技改变生活的理念，共享资源、共赢未来</h5>
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={8}>
            <Card plain>
              <GridItem className={classes.itemFlex}>
                <SearchIcon className={classes.icons} />
                <div className={classes.typo}>单位成立创新中心，与高校紧密合作，建立产学研机制，实行技术把关。</div>
              </GridItem>
            </Card>
            <Card plain>
              <GridItem className={classes.itemFlex}>
                <GroupIcon className={classes.icons} />
                <div className={classes.typo}>
                  拥有国家权威专家顾问团队，以超前的理念引领咨询工作，做到任何咨询建议均有理可依，避免走弯路。
                </div>
              </GridItem>
            </Card>
            <Card plain>
              <GridItem className={classes.itemFlex}>
                <AccountBalanceIcon className={classes.icons} />
                <div className={classes.typo}>
                  绿建、海绵技术服务均为主营业务，公司与政府主管部门互动紧密、沟通良好，能及时了解规范政策的最新动态，节约沟通成本。
                </div>
              </GridItem>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <Card plain>
              <GridItem className={classes.itemGrid}>
                <img src={architecture} alt="理念超前化" className={imageClasses} />
              </GridItem>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  )
}
